import React from "react";

import { Button } from "reactstrap";
import { Link } from "react-router-dom";
 
import { PAY_BALANCE, RENEWAL } from "../../pages/RenewPolicy/constants.js";
import { useSelector } from "react-redux";
import { getTransactionType } from "globals/auth";

/** @type {React.CSSProperties} */
// const style = {
// 	minWidth: "150px",
// 	color: "#fff",
// 	boxShadow: " 0 3px 6px rgba(0, 0, 0, 0.24), 0 4px 8px rgba(0, 0, 0, 0.24)",
// 	paddingTop: 6,
// 	paddingBottom: 6,
// 	textAlign: "center",
// 	fontSize: 16,
// 	// height: 40,
// 	borderRadius: 7,
// 	backgroundColor: "#0f2662",
// 	zIndex: 2,
// 	position: "relative",
// 	fontWeight: 400,
// 	marginTop:"2em !important",  
// 	alignSelf:"flex-end", 
// };

/**
 * A custom Button wrapper around reactstrap's Button
 * @param {Object} props
 * @param {String|JSX.Element} props.text
 * @param {String=} props.link
 * @param {String=} props.color
 * @param {String=} props.textColor
 * @param {String=} props.width
 * @param {() => void=} props.action
 * @param {Boolean=} props.disabled
 * @param {*=} props.type
 * @param {Object} props.style
 * @param {String=} props.className
 */
const CustomButtom = ({ text, link, width, action, disabled, type, style = {}, className = "button-v2 primary-theme-btn", children, ...rest }) => {
	const transactionType = useSelector(getTransactionType);

	return (
		<Button
			color="" // remove default 'btn-secondary' class
			tag={link ? Link : undefined}
			to={link}
			disabled={disabled}
			onClick={action}
			className={className}
			style={
				transactionType === PAY_BALANCE || transactionType === RENEWAL
					? {}
					: { ...style, width: width === undefined ? style.width : width }
			}
			type={type}
			{...rest}
		>	
			{children}
			{text}
		</Button>
	);
};

export default CustomButtom;
